<template>
  <div>
    <main role="main">
      <div class="container">
        <div class="row">
          <div class="col-12 top-margin">
            <h1>Allgemeine Geschäftsbedingungen</h1>
            <p
              style="font-weight: bold; padding-bottom: 10px;"
            >§1 Geltung gegenüber Unternehmern und Begriffsdefinitionen</p>
            <p>
              (1) Die nachfolgenden Allgemeinen Geschäftbedingungen gelten für alle Lieferungen zwischen uns und einem Verbraucher
              <br />in ihrer zum Zeitpunkt der Bestellung gültigen Fassung.
            </p>
            <p>
              Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder
              <br />ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können (§ 13 BGB).
            </p>
            <p
              style="font-weight: bold; padding-bottom: 10px;"
            >§2 Zustandekommen eines Vertrages, Speicherung des Vertragstextes</p>
            <p>(1) Die folgenden Regelungen über den Vertragsabschluss gelten für Bestellungen über unseren Internetshop https://www.sternenhimmel-poster.de .</p>
            <p>
              <b>(2) Im Falle des Vertragsschlusses kommt der Vertrag zustande mit</b>
            </p>
            <div style="font-weight: bold; margin-left: 20px;">
              Momentgold UG (haftungsbeschränkt)
              <br />Mittelstraße 24
              <br />D-10117 Berlin
              <br /><br />
            </div>
            <p>
              (3) Die Präsentation der Waren in unserem Internetshop stellen kein rechtlich bindendes Vertragsangebot unsererseits dar,
              <br />sondern sind nur eine unverbindliche Aufforderungen an den Verbraucher, Waren zu bestellen. Mit der Bestellung der gewünschten Ware gibt der Verbraucher ein für
              <br />ihn verbindliches Angebot auf Abschluss eines Kaufvertrages ab.
              <br />(4) Bei Eingang einer Bestellung in unserem Internetshop gelten folgende Regelungen:
              <br />Der Verbraucher gibt ein bindendes Vertragsangebot ab, indem er die in unserem Internetshop vorgesehene Bestellprozedur erfolgreich durchläuft.
            </p>
            <p>Die Bestellung erfolgt in folgenden Schritten:</p>
            <div>
              <p>1) Auswahl der gewünschten Ware</p>
              <p>2) Bestätigen durch Anklicken der Buttons „Bestellen“</p>
              <p>3) Prüfung der Angaben im Warenkorb</p>
              <p>4) Betätigung des Buttons „zur Kasse“</p>
              <p>5) Hinterlegung der Käuferinformationen im Internetshop (E-Mail-Adresse, Lieferadresse und Zahlungsabwicklung).</p>
              <p>
                <span
                  style="font-size: 1rem;"
                >6) Verbindliche Absendung der Bestellung durch Anklicken des Buttons „kostenpflichtig bestellen“ bzw. „kaufen“</span>
              </p>
            </div>
            <p>
              Der Verbraucher kann vor dem verbindlichen Absenden der Bestellung durch Betätigen der in dem von ihm verwendeten Internet-Browser enthaltenen „Zurück“-Taste nach
              <br />Kontrolle seiner Angaben wieder zu der Internetseite gelangen, auf der die Angaben des Kunden erfasst werden und Eingabefehler berichtigen bzw. durch Schließen des
              <br />Internetbrowsers den Bestellvorgang abbrechen.
              <br />Wir bestätigen den Eingang der Bestellung unmittelbar durch eine automatisch generierte E-Mail („Auftragsbestätigung“). Mit dieser nehmen wir Ihr Angebot an.
            </p>
            <p>
              (5) Speicherung des Vertragstextes bei Bestellungen über unseren Internetshop : Wir senden Ihnen die Bestelldaten per
              <br />E-Mail zu. Die AGB können Sie jederzeit auch unter https://www.sternenhimmel-poster.de/agb einsehen.
            </p>
            <p>Ihre Bestelldaten sind aus Sicherheitsgründen nicht mehr über das Internet zugänglich.</p>
            <p
              style="font-weight: bold; padding-bottom: 10px;"
            >§3 Preise, Versandkosten, Zahlung, Fälligkeit</p>
            <p>(1) Die angegebenen Preise enthalten die gesetzliche Umsatzsteuer und sonstige Preisbestandteile. Hinzu kommen etwaige Versandkosten.</p>
            <p>
              (2) Der Verbraucher hat die Möglichkeit der Zahlung per
              <span
                style="font-size: 1rem;"
              >Bankeinzug,</span>
              <span style="font-size: 1rem;">PayPal,</span>
              <span style="font-size: 1rem;">Kreditkarte</span>
              <span style="font-size: 1rem;">.</span>
            </p>
            <p>
              <span style="font-weight: bold; font-size: 1rem;">§4 Lieferung</span>
            </p>
            <p>
              (1) Sofern wir dies in der Produktbeschreibung nicht deutlich anders angegeben haben, sind alle von uns angebotenen Artikel nach der Herstellung versandfertig.
              <br />Die Lieferung erfolgt hier spätesten innerhalb von 14 Werktagen.
              <br />Fällt das Fristende auf einen Samstag, Sonntag oder gesetzlichen Feiertag am Lieferort, so endet die Frist am nächsten Werktag.
            </p>
            <p>
              (2) Die Gefahr des zufälligen Untergangs und der zufälligen Verschlechterung der
              <br />verkauften Sache geht auch beim Versendungskauf erst mit der Übergabe der Sache an den Käufer auf diesen über.
            </p>
            <p style="font-weight: bold; padding-bottom: 10px;">§5 Eigentumsvorbehalt</p>
            <p>Wir behalten uns das Eigentum an der Ware bis zur vollständigen Bezahlung des Kaufpreises vor.</p>
            <p>****************************************************************************************************</p>
          </div>
        </div>
        <div class0="row">
          <div class="col-12">
            <p
              id="cp"
              style="font-weight: bold; padding-bottom: 10px;"
            >§6 Widerrufsrecht des Kunden als Verbraucher:</p>
            <p>
              <b>
                Vorwort
              </b>
            </p>
            <p>
              Bitte beachten Sie, dass jedes Sternenhimmel Poster individuell angefertigt wird und somit kein gesetzliches Widerrufsrecht besteht.
            </p>
            <p>
              In besonderen Fällen nehmen wir aus Kulanz das Poster bei nichtgefallen eventuell bis zu 14 Tage lang zurück.
              Dies kann jedoch nur nach vorheriger Absprache erfolgen und nachdem wir es genehmigt haben.
            </p>
            <p>
              Ausgeschlossen sind Fehldrucke aufgrund von Eigenverschulden wie z.B Tippfehler, falsche Datumswahl, Widmungsänderungen etc.
            </p>
            <p>
              Die Rücksendekosten hat in jedem Fall der Käufer zu tragen.
            </p>
            <p>
              <b>
                Widerrufsrecht
              </b>
            </p>
            <p>
              Sie können Ihre Vertragserklärung innerhalb von 14 Tagen, ohne Angabe von Gründen, in Textform (z. B. Brief,
              Fax, E-Mail) oder – wenn Ihnen die Sache vor Fristablauf überlassen wird – durch Rücksendung der Sache widerrufen.
              Die Frist beginnt nach Erhalt dieser Belehrung in Textform, jedoch nicht vor Eingang der Ware beim Empfänger
              (bei der wiederkehrenden Lieferung gleichartiger Waren nicht vor Eingang der ersten Teillieferung) und
              auch nicht vor Erfüllung unserer Informationspflichten gemäß Artikel 246 § 2 in Verbindung mit § 1 Abs.
              1 und 2 EGBGB sowie unserer Pflichten gemäß § 312g Abs. 1 Satz 1 BGB in Verbindung mit Artikel 246 § 3 EGBGB.
            </p>
            <p>
              Zur Wahrung der Widerrufsfrist genügt die rechtzeitige Absendung des Widerrufs oder der Sache. Der Widerruf ist zu richten an:
            </p>
            <div style="margin-left: 20px; margin-top: 5px; margin-bottom: 5px;">
              <p>
                Momentgold UG (haftungsbeschränkt)
                <br />Mittelstraße 24
                <br />D-10117 Berlin
                <br />E-Mail support@{{rootDomain}}
              </p>
            </div>
            <p>
              Bitte teilen Sie uns Ihren Widerruf per E-Mail mit.
            </p>
            <p>
              <b>Widerrufsfolgen</b>
            </p>
            <p>
              Im Falle eines wirksamen Widerrufs sind die beiderseits empfangenen Leistungen zurückzugewähren und ggf.
              gezogene Nutzungen (z. B. Zinsen) herauszugeben. Können Sie uns die empfangene Leistung ganz oder teilweise
              nicht oder nur in verschlechtertem Zustand zurückgewähren, müssen Sie uns insoweit ggf. Wertersatz leisten.
              Bei der Überlassung von Sachen gilt dies nicht, wenn die Verschlechterung der Sache ausschließlich auf deren
              Prüfung – wie sie Ihnen etwa im Ladengeschäft möglich gewesen wäre – zurückzuführen ist. Für eine durch die
              bestimmungsgemäße Ingebrauchsnahme der Sache entstandene Verschlechterung müssen Sie keinen Wertersatz leisten.
              Paketversandfähige Sachen sind auf unsere Gefahr zurückzusenden. Verpflichtungen zur Erstattung von Zahlungen
              müssen innerhalb von 30 Tagen erfüllt werden. Die Frist beginnt für Sie mit der Absendung Ihrer Widerrufserklärung
              oder der Sache, für uns mit deren Empfang. Das Widerrufsrecht gilt dagegen nicht in den vom Gesetz geregelten
              Ausnahmefällen, insbesondere - bei Verträgen über Lieferung von Waren, die nach Kundenspezifikation angefertigt
              werden oder - bei Waren, die eindeutig auf die persönlichen Bedürfnisse des Kunden zugeschnitten sind oder -
              bei Waren, die aufgrund ihrer Beschaffenheit nicht für eine Rücksendung geeignet sind oder - bei Lieferung von Audio- oder
              Videoaufzeichnungen oder von Software, sofern die gelieferten Datenträger vom Kunden entsiegelt worden sind,
              ferner nicht bei Leistungen, die online (z.B. Software zum Download oder per eMail) übermittelt worden sind.
            </p>

            <p>
              <b>Ausschluss bzw. vorzeitiges Erlöschen des Widerrufsrechts</b>
            </p>
            <p>
              Das Widerrufsrecht besteht nicht bei Verträgen zur Lieferung von Waren, die nicht vorgefertigt sind und für
              deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist oder die
              eindeutig auf die persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind.
            </p>
            <p>
              Das Widerrufsrecht erlischt vorzeitig bei Verträgen zur Lieferung von digitalen Inhalten, wenn wir mit der
              Ausführung des Vertrages begonnen haben, nachdem Sie ausdrücklich zugestimmt haben, dass wir mit der Ausführung
              des Vertrages vor Ablauf der Widerrufsfrist beginnen und Sie uns Ihre Kenntnis davon bestätigt haben, dass
              Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags Ihr Widerrufsrecht verlieren.
            </p>
            <p>****************************************************************************************************</p>
            <!--            <p style="font-weight: bold; padding-bottom: 10px;">§7 Widerrufsformular</p>-->
            <!--            <p style="text-align: center; font-weight: bold;">Muster-Widerrufsformular</p>-->
            <!--            <p>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>-->
            <!--            <div style="border: 1px solid #000000; padding: 10px;">-->
            <!--              <p>-->
            <!--                An :-->
            <!--                <br />Momentgold UG (haftungsbeschränkt)-->
            <!--                <br />z.H. Duong Ta-->
            <!--                <br />Mittelstraße 24-->
            <!--                <br />D-10117 Berlin-->
            <!--                <br />E-Mail info@sternenhimmel-poster.de-->
            <!--              </p>-->
            <!--              <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)</p>-->
            <!--              <p>_____________________________________________________</p>-->
            <!--              <p>Bestellt am (*)/erhalten am (*)</p>-->
            <!--              <p>__________________</p>-->
            <!--              <p>Name des/der Verbraucher(s)</p>-->
            <!--              <p>_____________________________________________________</p>-->
            <!--              <p>Anschrift des/der Verbraucher(s)</p>-->
            <!--              <p>_____________________________________________________</p>-->
            <!--              <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>-->
            <!--              <p>__________________</p>-->
            <!--              <p>Datum</p>-->
            <!--              <p>__________________</p>-->
            <!--            </div>-->
            <!--            <p>(*) Unzutreffendes streichen.</p>-->
            <p style="font-weight: bold; padding-bottom: 10px;">§7 Gewährleistung</p>
            <p>Es gelten die gesetzlichen Gewährleistungsregelungen.</p>
            <p style="font-weight: bold; padding-bottom: 10px;">§8 Vertragssprache</p>
            <p>Als Vertragssprache steht ausschließlich Deutsch zur Verfügung.</p>
            <p>Stand der AGB Apr.2020</p>
            <p>
              <i>
                <a href="http://www.agb.de">Gratis AGB</a> erstellt von agb.de
              </i>
            </p>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
  import Footer from "../../components/Footer";

  export default {
    name: "TermCondition",
    data() {
      return {
        rootDomain: process.env.VUE_APP_ROOT_DOMAIN,
      };
    },
    components: {
      Footer,
    },
    mounted: () => {
      window.scrollTo(0, 0);
    },
  };
</script>

<style scoped>
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  div {
    color: #7a7a7a;
  }

  p {
    font-size: 19px;
  }

  h1,
  h2 {
    word-break: break-all;
  }

  .top-margin {
    margin-top: 75px;
  }
</style>
